"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverFeatures = void 0;
const PermissionName_1 = require("../Permission/PermissionName");
const NativeFeatureIdentifier_1 = require("../Feature/NativeFeatureIdentifier");
const domain_core_1 = require("@standardnotes/domain-core");
function serverFeatures() {
    return [
        {
            name: 'Two factor authentication',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TwoFactorAuth,
            permission_name: PermissionName_1.PermissionName.TwoFactorAuth,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'U2F authentication',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.UniversalSecondFactor,
            permission_name: PermissionName_1.PermissionName.UniversalSecondFactor,
            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Unlimited note history',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.NoteHistoryUnlimited,
            permission_name: PermissionName_1.PermissionName.NoteHistoryUnlimited,
            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: '365 days note history',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.NoteHistory365Days,
            permission_name: PermissionName_1.PermissionName.NoteHistory365Days,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser],
        },
        {
            name: 'Email backups',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DailyEmailBackup,
            permission_name: PermissionName_1.PermissionName.DailyEmailBackup,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Sign-in email alerts',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SignInAlerts,
            permission_name: PermissionName_1.PermissionName.SignInAlerts,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Files maximum storage tier',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.FilesMaximumStorageTier,
            permission_name: PermissionName_1.PermissionName.FilesMaximumStorageTier,
            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Files low storage tier',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.FilesLowStorageTier,
            permission_name: PermissionName_1.PermissionName.FilesLowStorageTier,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser],
        },
        {
            name: 'Files medium storage tier',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SubscriptionSharing,
            permission_name: PermissionName_1.PermissionName.SubscriptionSharing,
            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Listed Custom Domain',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.ListedCustomDomain,
            permission_name: PermissionName_1.PermissionName.ListedCustomDomain,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
        },
        {
            name: 'Shared Vaults',
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SharedVaults,
            permission_name: PermissionName_1.PermissionName.SharedVaults,
            availableInRoles: [domain_core_1.RoleName.NAMES.InternalTeamUser],
        },
    ];
}
exports.serverFeatures = serverFeatures;
